<template>
    <div>
        <!-- Title -->
        <component
            :is="collapsable ? 'button' : 'div'"
            @click="collapsable ? (expanded = !expanded) : null"
            :class="[
                { 'group hover:scale-[101%]': collapsable },
                'w-full flex items-center justify-between py-4 transition-transform duration-250 ease-in-out',
                borderClass,
            ]"
        >
            <p class="text-xl xl:text-2xl font-header font-semibold">
                {{ name }}
            </p>
            <div
                v-if="collapsable"
                :class="[
                    expanded
                        ? '[transform:rotateX(0deg)]'
                        : '[transform:rotateX(180deg)]',
                    'size-8 flex-shrink-0 transition-transform duration-500 ease-in-out',
                ]"
            >
                <PhCaretUp
                    class="size-8 flex-shrink-0 transition-transform duration-250 ease-in-out group-hover:scale-110"
                />
            </div>
        </component>
        <!-- Roles -->
        <VerticalSlideTransition :show="!collapsable || expanded">
            <slot></slot>
        </VerticalSlideTransition>
    </div>
</template>

<script>
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'
import { PhCaretUp } from '@phosphor-icons/vue'

export default {
    name: 'CollapsibleSection',

    components: {
        VerticalSlideTransition,
        PhCaretUp,
    },

    props: {
        name: {
            type: String,
            required: true,
        },
        collapsable: {
            type: Boolean,
            default: false,
        },
        borderClass: {
            type: String,
            default: 'border-b border-border-darker',
        },
        expandedStart: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            expanded: this.expandedStart,
        }
    },
}
</script>
